var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMarkEmailReadFill = function SvgMarkEmailReadFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mark_email_read_fill_svg__a",
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h50v50H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mark_email_read_fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4000FF",
    d: "M8.973 40.625a3.63 3.63 0 0 1-2.662-1.104 3.63 3.63 0 0 1-1.104-2.662V13.14q0-1.558 1.104-2.662a3.63 3.63 0 0 1 2.662-1.104h32.051q1.56 0 2.663 1.104a3.63 3.63 0 0 1 1.103 2.662v8.105q0 .753-.292 1.448a3.7 3.7 0 0 1-.805 1.208L32.779 34.796l-3.301-3.302q-1.078-1.077-2.669-1.077t-2.668 1.077l-2.784 2.785q-1.01 1.009-.926 2.462a4.9 4.9 0 0 0 .942 2.638q.284.396.096.821-.189.425-.681.425zM25 22.917l-14.46-9.251q-.645-.413-1.316-.072-.67.34-.73 1.081-.08.39.077.74.158.35.515.57l14.9 9.54q.48.292 1.014.292a1.9 1.9 0 0 0 1.013-.292l14.9-9.54q.357-.24.515-.59t.078-.74q-.06-.741-.731-1.071-.67-.33-1.316.082zm7.748 17.764L43.46 29.968a1.5 1.5 0 0 1 1.098-.453q.645 0 1.098.453.452.453.452 1.098t-.452 1.097l-11.59 11.59a1.9 1.9 0 0 1-.618.43q-.324.136-.701.136t-.701-.136a1.9 1.9 0 0 1-.617-.43l-5.717-5.716a1.5 1.5 0 0 1-.453-1.098q0-.645.453-1.098a1.5 1.5 0 0 1 1.098-.452q.645 0 1.097.452z"
  }))));
};
export default SvgMarkEmailReadFill;